$(() => {
  if ($(".places-form-i-controls_openable-text").length < 1) {
    return
  }

  $(".places-form-i-controls_openable-text .radio-label_first").on(
    "click",
    function focusInput() {
      const $label = $(this)
      setTimeout(() => {
        $label
          .parent()
          .parent()
          .find("input:not([type=radio])")
          .trigger("focus")
      }, 0)
    },
  )

  $(".places-form-i-controls_openable-text input[type=radio]").on(
    "change",
    function saveValue() {
      localStorage.setItem($(this).attr("name"), $(this).val())
    },
  )
  ;["pms", "crs", "channel_manager"].forEach((fieldName) => {
    const value = localStorage.getItem(fieldName)
    if (value) {
      $(`input[name=${fieldName}][value=${value}]`).prop("checked", true)
    }
  })
})
